module.exports = __webpack_public_path__ + "img/MarketInsights.2e6897ac.png";